import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, NavigationEnd, PRIMARY_OUTLET, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'lib-breadcrumb',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {


  public breadcrumbs: Breadcrumb[] = []; ;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {

    this.route.data.subscribe((d:any) => {
      this.runActivate();
    })
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      this.runActivate();
    });
  }

  private runActivate(){
    let root: ActivatedRoute = this.route.root;
    this.breadcrumbs = this.getBreadcrumbs(root);
     this.breadcrumbs = [...this.breadcrumbs];
  }

  private getBreadcrumbs(route: ActivatedRoute, url: string = "", breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
    const ROUTE_DATA_BREADCRUMB = 'title';
    let children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (let child of children) {
      if (!(child.outlet !== PRIMARY_OUTLET || child.snapshot.url.length==0)) {
        if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
          return this.getBreadcrumbs(child, url, breadcrumbs);
        }
        let routeURL: string = child.snapshot.url.map(segment => segment.path).join("/");

        url += `/${routeURL}`;

        let breadcrumb: Breadcrumb = {
          label: child.snapshot.data[ROUTE_DATA_BREADCRUMB],
          url: url
        };
        breadcrumbs.push(breadcrumb);

      }
      return this.getBreadcrumbs(child, url, breadcrumbs);
    }
    return breadcrumbs;
  }
}

export interface Breadcrumb{
  label: string;
  url: string;
}

